import { z } from 'zod'

import type { AnyRecord, ZodInfer } from '@mntn-dev/utility-types'

import { BillingServiceIdSchema } from '../billing-service.models.ts'

export const CreditCardBillingServiceCustomerSchema = z.object({
  id: BillingServiceIdSchema,
  email: z.email(),
  name: z.string(),
})

export type CreditCardBillingServiceCustomer = ZodInfer<
  typeof CreditCardBillingServiceCustomerSchema
>

export const CreditCardBillingServiceCustomer = (obj: AnyRecord) =>
  CreditCardBillingServiceCustomerSchema.parse(obj)
